import { render, staticRenderFns } from "./BrandKeywords.vue?vue&type=template&id=2ce859ae&scoped=true&"
import script from "./BrandKeywords.vue?vue&type=script&lang=js&"
export * from "./BrandKeywords.vue?vue&type=script&lang=js&"
import style0 from "./BrandKeywords.vue?vue&type=style&index=0&id=2ce859ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce859ae",
  null
  
)

export default component.exports